export default "__VITE_ASSET__g$D8nYXQ__"